// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1FryV","logoutBtn":"Header_logoutBtn__3vxl8"};